module.exports = __webpack_public_path__ + "static/img/logo-scroll.177781e6.svg";